(function ($) {

    $(document).ready(function () {

        if ($('.team-container .container, .hospital-transition-team').length) {

            $(window).on('resize', function () {
                if ($('.info-block.active').length) {
                    setPopupPosition($('.info-block.active'));
                }
            });

            $(".info-block").on('click', function () {
                $('.info-block.active').removeClass('active');
                //removing class active from partner-block (bugfix)
                setPopupPosition($(this));
            });


            $(".popup .close").on('click', function () {
                $(this).parent('.popup').fadeOut(300);
                $('.info-block.active').removeClass('active');
            });


            function setPopupPosition($this) {
                $this.addClass('active');
                var popup = $this.data('popup'),

                    his_popup = $this.closest('.team-container .container, .hospital-transition-team .container').find('.popup.' + popup),

                    top = $this.offset().top + $this.find('img').height() - $this.closest('.team-container .container, .hospital-transition-team .container').offset().top + 10,
                    left = $this.offset().left + ($this.width() / 2) - $this.closest('.team-container .container, .hospital-transition-team .container').offset().left,
                    currentWidth = $this.width() + 100;


                $(".popup").not(his_popup).fadeOut(300);
                his_popup.parent('.popups').css('top', top + 'px');
                his_popup.find('.top-info').css({
                    'width': currentWidth + 'px',
                    'left': $this.offset().left - $this.closest('.team-container .container, .hospital-transition-team .container').offset().left + 31
                });
                his_popup.fadeIn(300).find('.arrow').css('left', left);
            }

        }
    });

})(jQuery);